export { LatestArticles as default } from './LatestArticles';
